<div class="tiny-container w-full !px-0">
  <dojo-selection-list
    class="swiper-detail-view"
    (optionSelected)="optionSelected.emit($event)"
    [formCtrl]="formCtrl"
    [options]="options"
    [multiple]="false"
    [labelsAreTranslationKeys]="true"
    [figureIconSize]="35"
  />
</div>
